// import { WrappedGroupDetailPage } from './lib/GroupDetail';
import { WrappedGroupDetailPage } from './lib/GroupDetail2';

export * from './lib/components';
export default WrappedGroupDetailPage;
